export const METRICS_PAGE_ID = 'board-settings-apps.swimlanes-page';

export const BOARD_SETTINGS_ARTICLE_ID_SWIMLANES_JSW = '26QjET7Idnvub96iZ7bYS6';
export const BOARD_SETTINGS_ARTICLE_ID_SWIMLANES_JSM = '3y9Pa9ks6EXBYKtnZKEeem';
export const BOARD_SETTINGS_ARTICLE_ID_SWIMLANES_JSW_ANALYTICS_ID = `${METRICS_PAGE_ID}.jsw.swimlanes.cmp.article.analytics`;
export const BOARD_SETTINGS_ARTICLE_ID_SWIMLANES_JSM_ANALYTICS_ID = `${METRICS_PAGE_ID}.jsm.swimlanes.cmp.article.analytics`;

export const SWIMLANE_STRATEGY_FIELD_WIDTH = 232;
